<template>
    <div id="news">
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
                <div class="container text-center"><h1 class="text-white">Новости</h1><Breadcrumbs title="Новости"/></div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <card class="border-0" shadow
                              body-classes="px-0">
                            <div class="row newsSort mx-0" v-on:click="loadInfo('all')">
                                <h6 class="d-flex align-items-center mb-0 text-uppercase">Новости</h6></div>
                            <div class="row newsSort mx-0" v-on:click="loadInfo('forum')">
                                <h6 class="d-flex align-items-center mb-0 text-uppercase">Форумы и конференции</h6></div>
                            <div class="row newsSort mx-0" v-on:click="loadInfo('activity')">
                                <h6 class="d-flex align-items-center mb-0 text-uppercase">Мероприятия</h6></div>
                            <div class="row newsSort mx-0" v-on:click="loadInfo('webinar')">
                                <h6 class="d-flex align-items-center mb-0 text-uppercase">Вебинары</h6></div>
                            <div class="row newsSort mx-0" v-on:click="loadInfo('innovations')">
                                <h6 class="d-flex align-items-center mb-0 text-uppercase">Нововведения</h6></div>
                        </card>
                    </div>
                     <div v-if="news" class="col-lg-8">
                         <card v-for="item in news.slice(perPage*(this.currentPage-1),perPage*(this.currentPage))"
                               :key="item.id"
                               class="border-0 mb-3" shadow>
                             <div class="row">
                                 <div class="col-lg-2 small text-default">{{ item.CREATED_DATE }}</div>
                                 <div class="col-lg-8">
                                     <h6>{{ item.NAME }}</h6>
                                 </div>
                             </div>
                             <div class="row">
                                 <div class="col-lg-2 small text-default"></div>
                                 <div class="col-lg-8" v-html="item.PREVIEW_TEXT"></div>
                                 <div class="col-lg-12">
                                     <router-link v-if="item.CODE" :to="'/new/' + item.CODE">
                                         <base-button type="default"
                                                      class="float-right">
                                             Подробнее
                                         </base-button>
                                     </router-link>
                                     <router-link v-else :to="'/new/' + item.ID">
                                         <base-button type="default"
                                                      class="float-right">
                                             Подробнее
                                         </base-button>
                                     </router-link>
                                 </div>
                             </div>
                         </card>
                        <base-pagination :total="totalRows" 
                                         v-model="currentPage"
                                         :per-page="perPage"></base-pagination>
                     </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import BasePagination from "@/components/BasePagination.vue";
    export default {
        components: {
            BasePagination
        },
        data() {
            return {
                news: [],
                perPage: 10,
                currentPage: 1,
                totalRows: null
            };
        },
        methods: {
            async loadInfo(id_tab) {
                let params = new Map();
                params.set('entity', 'news');
                if (id_tab != 'all') {
                    params.set('SECTION_CODE', id_tab);
                }

                this.news = await this.$root.loadContent(params)

                let params_2 = new Map();
                params_2.set('entity', 'pages');
                params_2.set('code', 'news');

                let seo = await this.$root.loadContent(params_2)
                this.$root.title = seo[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = seo[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            },
        },
        created() {
            this.loadInfo('all')
        },
    };
</script>
<style>
.bg { 
    min-height: 238px;
    background-image: url("/img/theme/bg-image.jpg");

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.page-item.active .page-link{
    background-color: var(--default) !important;
    border-color: var(--default) !important;
}
.newsSort{
    height:40px;
    padding-left: 15px
}
.newsSort:hover{
    background-color:var(--default);
    cursor:pointer;
}
.newsSort:hover > h6{
    color: white;
}
#news h6{
    font-family: Montserrat-Bold !important;
}
</style>